module.exports = __webpack_public_path__ + "static/features-034ac12d387cef0f0b21828e90f60aae.png";